import React, { useContext } from 'react';
import './style/CancelPlanCard.scss'
import { useTranslation } from 'react-i18next';
import AppContext from '../../config/AppContext';
import { Box, Typography } from '@mui/material';
import { ReactComponent as ArrowBackIconBack } from "../../assets/subscription/leftArrow.svg";
import CommonUtil from '../../util/CommonUtils';

const CancelPlanCard = ({ remainingDays = "30",marginLeft=0, onClick = () => { }, maxWidth = "100%" }) => {
    const { t } = useTranslation();
    const { mode } = useContext(AppContext);

    return (
        <div className='cancel-plan-card-main'
            style={{
                background: mode === "dark" ? "#333333" : "#FFFFFF",
                maxWidth: maxWidth,
                marginLeft:marginLeft
            }}
        >
            <div className='cancel-plan-card-header'>
                <Typography
                    className={CommonUtil.getOS() === "MacOS"
                        ? "mac-cancel-plan-card-back"
                        : "cancel-plan-card-back"
                    }

                >{t("RAL0873")}</Typography>
                <Box display="flex" alignItems="center" gap="2px" onClick={onClick}>
                    <Typography className='cancel-plan-card-back'
                        sx={{
                            color: mode === "light" ? "#1D0B77" : "#FA9C2B",
                            cursor: "pointer",
                            font: "normal normal normal 18px/21px GothamBold !important",
                            '@media (max-width: 1600px)': {
                                font: "normal normal normal 16px/19px GothamBold !important",
                            },
                        }}
                    >{t("RAL0874")}</Typography>
                    <ArrowBackIconBack
                        fontSize='large'
                        style={{
                            width: "18px",
                            rotate: "180deg",
                            fill: mode === "light" ? "#1D0B77" : "#FA9C2B"
                        }} />
                </Box>
            </div>
            <div className='cancel-plan-card-content'>
                {t("RAL0875", { remainingDays })}
            </div>

        </div>
    )
}

export default CancelPlanCard
